import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M16.576 2.576a3.428 3.428 0 1 1 4.848 4.848L10.118 18.73c-.244.244-.403.404-.582.542a3.595 3.595 0 0 1-.505.328c-.2.107-.41.188-.731.312l-.155.06-.057.021-5.373 2.067a.6.6 0 0 1-.775-.776L4.088 15.7c.123-.321.204-.532.311-.732a3.6 3.6 0 0 1 .328-.504 6.39 6.39 0 0 1 .542-.582L16.576 2.576ZM5.229 16.08c-.028.069-.063.16-.11.283l-1.574 4.091 4.09-1.573.04-.015c.104-.04.182-.071.244-.097a13.05 13.05 0 0 0-.214-.216l-2.259-2.26a13.096 13.096 0 0 0-.217-.213Zm3.752 2.085a1.846 1.846 0 0 0-.06-.075c-.094-.113-.22-.239-.351-.37l-2.291-2.29a5.985 5.985 0 0 0-.37-.35 1.812 1.812 0 0 0-.076-.06c.072-.077.169-.174.311-.316l11.28-11.28a2.228 2.228 0 0 1 3.152 3.152l-11.28 11.28c-.143.142-.24.238-.315.31Z"
      clip-rule="evenodd"
    />
  </svg>
`;
